import React, { useState } from 'react';
import { Pagination } from "react-bootstrap";

import "./style.scss";

const Paginator = ({ totalPages, onPageChange }) => {
  const [active, setActive] = useState(1);
  const numbersArray = Array.from({ length: totalPages }, (_, index) => index + 1);

  const handlePageChange = number => {
    setActive(number);
    onPageChange(number);
  }

  return (
    <Pagination>
      {numbersArray.map((number) => (
        <Pagination.Item
          key={number}
          active={number === active}
          className="pagination-list"
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      ))}
    </Pagination>
  );
};

export default Paginator;
